import { render, staticRenderFns } from "./DialogLicenseOemLocked.vue?vue&type=template&id=54371259"
import script from "./DialogLicenseOemLocked.vue?vue&type=script&lang=js"
export * from "./DialogLicenseOemLocked.vue?vue&type=script&lang=js"
import style0 from "./DialogLicenseOemLocked.vue?vue&type=style&index=0&id=54371259&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QItem from 'quasar/src/components/item/QItem.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QCardSection,QIcon,QSpace,QBtn,QItem});qInstall(component, 'directives', {ClosePopup});
